"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductRecommendations = void 0;
var product_recommendations_1 = require("./product-recommendations");
Object.defineProperty(exports, "ProductRecommendations", { enumerable: true, get: function () { return product_recommendations_1.ProductRecommendations; } });
